module.exports = __webpack_public_path__ + "static/spas-direct-327fcfd14054583ceae66d4ed5f65ec2.png";